import { GridValueGetterParams } from '@mui/x-data-grid-pro';

export const booleanValueGetter = (params: GridValueGetterParams): boolean => {
  const { row, field } = params;
  return !!row.flags.includes(field);
};
